import { useState } from "react";
import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";
import SideBar from "../components/SideBar";
import { AuthProvider } from "../components/AuthContext";
import { AuthProvider as KeycloakAuthProvider } from "react-oidc-context";
import { oidcConfig } from "@/utils/oidcConfig";

export default function App() {

    let [menuOpen, setMenuOpen] = useState(true);
    

    return (
        <div className="flex flex-col h-screen">
            <KeycloakAuthProvider {...oidcConfig}>
                <AuthProvider>
                    <NavBar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
                    <div className="flex flex-1">
                        

                        {/* Overlay for mobile */}
                        {menuOpen && (
                            <div
                            className="fixed inset-0 top-0 bg-black bg-opacity-50 md:hidden"
                            onClick={() => setMenuOpen(false)}
                            ></div>      )}
                        
                        <SideBar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

                        {/* Main content */}
                        <div className="flex-1">
                            <Outlet />
                        </div>
                    </div>
                </AuthProvider>
            </KeycloakAuthProvider>
        </div>
    )
}